@if (this.puffDataToUse()) {
  <div [ngClass]="'puff-container-' + index()" class="vd-card vd-card-white puff-container">
    <div class="puff-image-container">
      <app-media-item
        [image]="puffImage()"
        [isNarrowColumnImage]="true"
        [isPriority]="index() < numberOfPriorityPuffs()"
        [routePath]="routePath()"
      ></app-media-item>
    </div>
    <div [ngClass]="contentCssClass()" class="puff-text-container relative">

      @if (isSponsored()) {
        <span class="label absolute top-[-.75rem] left-0 right-0">ANNONS</span>
      }

      <a
        [eventAction]="'ad click'"
        [eventCategory]="adName()"
        [eventParams]="customGa4Params()"
        [innerHTML]="puffTitle()"
        [ngClass]="titleCssClass()"
        [routerLink]="routePath()"
        appGtmEvent
        appGtmGa4Event
        class="block text-left text-xl font-bold"
      ></a>

      <div class="vd-card-content">
        <div [innerHtml]="puffContent()"></div>
        <div [innerHtml]="puffCaption()" class="caption"></div>

        @if (puffDfpPixelName() !== '') {
          <app-standard-dfp-banner-loader
            [size]="[[1, 1]]"
            [unitName]="puffDfpPixelName()"
          ></app-standard-dfp-banner-loader>
        }
      </div>
    </div>
  </div>
}

